import { GenericRequestBody, GenericResponse } from '@omnea-digital/toolbox'
import createClient from 'openapi-fetch'
import { withErrorCapture } from '@omnea-app/packages/universal/general/observability/withErrorCapture'
import { ServiceUrls } from '@omnea-app/packages/universal/general/serviceUrls'
import { components, paths } from './usersGeneratedTypes'

export class UsersHttpClient {
  GET
  POST
  constructor({ omneaJwt }: { omneaJwt: string }) {
    const { GET, POST } = createClient<paths>({ baseUrl: ServiceUrls.USERS, headers: { Authorization: `Bearer ${omneaJwt}` } })
    this.GET = withErrorCapture({ method: GET })
    this.POST = withErrorCapture({ method: POST })
  }
}

export type OmneaUser = components['schemas']['UserInfo']

export type UserWithPreferences = {
  user: OmneaUser
  notificationPreferences: components['schemas']['NotificationPreferences']
}

export type NotificationType = keyof Omit<components['schemas']['NotificationPreferences'], 'channels'>

export type UserResponse<T extends keyof paths, T2 extends keyof paths[T]> = GenericResponse<paths, T, T2>
export type UserRequestBody<T extends keyof paths, T2 extends keyof paths[T]> = GenericRequestBody<paths, T, T2>
